import { useTranslation } from "react-i18next";

/** Which colour means what: per axis its name, the colour at its low end and at its high end. */
export function AxisLegend({ axes }: { axes: { label: string; low: string; high: string }[] }) {
  const { t } = useTranslation();
  const swatch = (c: string) => (
    <span aria-hidden className="inline-block h-2.5 w-2.5 rounded-[3px]" style={{ background: c }} />
  );
  return (
    <ul
      className="flex flex-wrap items-center gap-x-4 gap-y-1 px-1 text-[11px] text-neutral-500"
      aria-label={t("views.axisLegend")}
      data-testid="axis-legend"
    >
      {axes.map((a) => (
        <li key={a.label} className="inline-flex items-center gap-1">
          <span className="text-neutral-600 dark:text-neutral-300">{a.label}</span>
          {swatch(a.low)}
          <span>{t("views.axisLow")}</span>
          <span aria-hidden>→</span>
          {swatch(a.high)}
          <span>{t("views.axisHigh")}</span>
        </li>
      ))}
    </ul>
  );
}
